export default __webpack_public_path__ + "static/media/icons-add.78cb6958.svg";